import React from "react"
import { css } from "react-emotion"

import { Button, ButtonModal } from "ui"
import AttributesForm from "features/records/components/AttributesForm"

const NewRecordButton = props => (
    <ButtonModal
        button={({ open }) => (
            <Button size="small" sideMargin="small" margin={"small"} onClick={open}>
                New {props.object.name}
            </Button>
        )}
        header={() => `New ${props.object.name}`}
        footerClassName={css`
            justify-content: flex-end;
        `}
        footer={({ close, state }) => [
            <Button
                key="create"
                sideMargin="xsmall"
                color="success"
                onClick={() => {
                    props.onSave(state)
                    close()
                }}
            >
                Create
            </Button>,
            <Button key="cancel" sideMargin="xsmall" onClick={close}>
                Cancel
            </Button>,
        ]}
    >
        {({ setState }) => <AttributesForm onChange={setState} fields={props.object.fields} />}
    </ButtonModal>
)
export default NewRecordButton



// WEBPACK FOOTER //
// ./src/features/studio/components/NewRecordButton.js